import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { PedidoService } from 'src/app/dao/pedido.service';

@Component({
  selector: 'app-selecao-tipo-pedido',
  templateUrl: './selecao-tipo-pedido.page.html',
  styleUrls: ['./selecao-tipo-pedido.page.scss'],
})
export class SelecaoTipoPedidoPage implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private toast: ToastService, private pedidoApi: PedidoService) { }
  
  tipoPedido;


  ngOnInit() {
  }


  async onSubmit2(tipo) {
    try {
      this.tipoPedido = tipo;
      this.router.navigate(['/pedido-list/', this.tipoPedido]);
    } catch (error) {
      // this.toast.showError('Ocorreu um erro ao tentar salvar o Produto');
      console.log(error);
    }

  }

}
